import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useUsersStore } from '../store/usersStore'
import { addUser } from '../utils/addUser'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useAddUserMutation = (onSuccess?: () => void) => {
  const add = useUsersStore((state) => state.add)

  return useMutation({
    mutationFn: addUser,
    onSuccess: ({ message, user }) => {
      add(user)
      toast.success(message || 'User created successfully.')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(error, 'An error occurred while creating user.')
    },
  })
}
